function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "edit_icon",
  transform: "translate(-0.248 -0.242)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6580",
  "data-name": "Path 6580",
  d: "M20.361,14.14l-6.109,6.109-3,.6.6-3,6.109-6.109a1.694,1.694,0,0,1,2.4,0l.006.007a1.692,1.692,0,0,1,0,2.395Z",
  transform: "translate(-2.094 -2.094)",
  fill: "none",
  stroke: "#b1b1b1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6581",
  "data-name": "Path 6581",
  d: "M6.754,16.653h-4.8a1.172,1.172,0,0,1-1.2-1.2V3.529a1.247,1.247,0,0,1,1.2-1.287H13.96a1.247,1.247,0,0,1,1.2,1.287V7.046",
  transform: "translate(0 -0.299)",
  fill: "none",
  stroke: "#b1b1b1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_67",
  "data-name": "Line 67",
  y2: 3.603,
  transform: "translate(4.353 0.742)",
  fill: "none",
  stroke: "#b1b1b1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_68",
  "data-name": "Line 68",
  y2: 3.603,
  transform: "translate(7.955 0.742)",
  fill: "none",
  stroke: "#b1b1b1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y2: 3.603,
  transform: "translate(11.558 0.742)",
  fill: "none",
  stroke: "#b1b1b1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgEditIcon = function SvgEditIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.015,
    height: 19.014,
    viewBox: "0 0 19.015 19.014",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit_icon.67816121.svg";
export { ForwardRef as ReactComponent };